import { Injectable, inject } from '@angular/core';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { HttpClient } from '@angular/common/http';
import { TRADGINE_DATA_API_BASE_URL } from '../api-base-url.token';
import { TradingProcedureLandingResponseDto } from '../schemas/trading-procedure-responses/trading-procedure-landing-response.dto';

@Injectable({ providedIn: 'root' })
export class TradingProcedureLandingApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(TRADGINE_DATA_API_BASE_URL)}/tradingProcedureLanding`;

    getAll() {
        return this.builder
            .url(`${this.controllerUrl}/getAll`)
            .get()
            .json<TradingProcedureLandingResponseDto[]>()
            .build()
            .send();
    }
}
